export const DEFAULT_ACCEPT = 'application/pdf';
export const RECEIPT_MIME_TYPES = ['application/pdf', 'image/*', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

export const COMPLETED_THRESHOLD = 98;
export const DEFAULT_VIDEO_MIME_TYPE = 'video/mp4';
export const DEFAULT_AUDIO_MIME_TYPE = 'audio/mpeg';
export const DEFAULT_PERSISTENCE = 'LOCAL';

export const DEFAULT_FILE_INPUT = { files: null, isValid: false, showErrors: false, value: '' };
export const DEFAULT_STRING_INPUT = { isValid: false, showErrors: false, value: '' };
export const DEFAULT_NUMBER_INPUT = { isValid: false, showErrors: false, value: null };
export const DEFAULT_INPUT_CHECK = { isValid: true, value: false };
export const DEFAULT_INPUT_IMAGE = { image: null, isValid: false, showErrors: false, value: '' };

export const EMAIL_REGEXP = /^[-_@',.\\/!:a-zA-Z0-9\s]{2,250}$/;
export const NAME_REGEXP = /^[-a-zA-Z\s]{2,20}$/;
export const TEXT_REGEXP = /^[-_',.\\/!:a-zA-Z0-9\s]{2,500}$/;
export const TOPIC_REGEXP = /^[-_',.:a-zA-Z0-9\s]{10,30}$/;
export const TITLE_REGEXP = /^[-_',.:a-zA-Z0-9\s]{3,30}$/;
export const PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
export const BANK_ACCOUNT_REGEXP = /^[a-zA-Z0-9\s]{10,30}$/;
export const HEADLINE_REGEXP = /^[-_',.:a-zA-Z0-9\s]{10,60}$/;
export const PASSWORD_HELPER_TEXT = 'minimum length 8, at least 1 uppercase, 1 lowercase, 1 special character and 1 number';
export const SALARY_REGEXP = /^[0-9]{1,6}$/;
export const CHARGE_HOUR_REGEXP = /^([1-9]|1[0-9]|2[0-4])$/;
export const DOCUMENT_NAME_REGEXP = /^[-_a-zA-Z0-9(). ]{2,50}$/;

export const TOPIC_MAX_LENGTH = 30;
export const TITLE_MAX_LENGTH = 30;
export const HEADLINE_MAX_LENGTH = 60;

export const ACTIVE_ENUM = ['true', 'false'];
export const INFO_EDIT_ROLES = ['Admin', 'Editor'];
export const ALLOWED_THEMES = ['light', 'dark'];

export const UNAUTHORIZED_MESSAGE = 'Unauthorized!';
export const PROFILE_PICTURE_FOLDER = 'profilePictures';
export const TUTORIALS_FOLDER = 'tutorials';
export const DOCUMENTS_FOLDER = 'documents';
export const INTRO_VIDEOS_FOLDER = 'intro';
export const CURRENTLY_WATCHING = 'currentlyWatching';
export const CURRENTLY_WATCHING_INTRO = 'currentlyWatchingIntro';
export const CATEGORIZE_COURSES_KEY = 'categorizeCourses';
export const CATEGORIZE_WISHES_KEY = 'categorizeWishes';
export const COMPLETED = 'completed';
export const NUMBER_OF_VIDEOS = 'numberOfVideos';

export const RETRY_INTERVAL = 250; // amount of time in milliseconds to wait before re0querying firestore for dat;
export const AUTO_LOGOUT_DURATION = 172800000; // 2 days in milliseconds ('1.728e+8';
export const CARD_WIDTH = 250;
export const CARD_MARGIN = 5;
export const DRAWER_WIDTH = 240;
export const MAX_RETRIES = 5;
export const COMING_SOON_MESSAGE = 'Unpublished tutorial. Please check back later!';

export const COUNTRY_DETAILS = [
  { code: 'AF', dial: '+93', flag: '🇦🇫', name: 'Afghanistan' },
  { code: 'AX', dial: '+358', flag: '🇦🇽', name: 'Åland Islands' },
  { code: 'AL', dial: '+355', flag: '🇦🇱', name: 'Albania' },
  { code: 'DZ', dial: '+213', flag: '🇩🇿', name: 'Algeria' },
  { code: 'AS', dial: '+1684', flag: '🇦🇸', name: 'American Samoa' },
  { code: 'AD', dial: '+376', flag: '🇦🇩', name: 'Andorra' },
  { code: 'AO', dial: '+244', flag: '🇦🇴', name: 'Angola' },
  { code: 'AI', dial: '+1264', flag: '🇦🇮', name: 'Anguilla' },
  { code: 'AQ', dial: '+672', flag: '🇦🇶', name: 'Antarctica' },
  { code: 'AG', dial: '+1268', flag: '🇦🇬', name: 'Antigua and Barbuda' },
  { code: 'AR', dial: '+54', flag: '🇦🇷', name: 'Argentina' },
  { code: 'AM', dial: '+374', flag: '🇦🇲', name: 'Armenia' },
  { code: 'AW', dial: '+297', flag: '🇦🇼', name: 'Aruba' },
  { code: 'AU', dial: '+61', flag: '🇦🇺', name: 'Australia' },
  { code: 'AT', dial: '+43', flag: '🇦🇹', name: 'Austria' },
  { code: 'AZ', dial: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
  { code: 'BS', dial: '+1242', flag: '🇧🇸', name: 'Bahamas' },
  { code: 'BH', dial: '+973', flag: '🇧🇭', name: 'Bahrain' },
  { code: 'BD', dial: '+880', flag: '🇧🇩', name: 'Bangladesh' },
  { code: 'BB', dial: '+1246', flag: '🇧🇧', name: 'Barbados' },
  { code: 'BY', dial: '+375', flag: '🇧🇾', name: 'Belarus' },
  { code: 'BE', dial: '+32', flag: '🇧🇪', name: 'Belgium' },
  { code: 'BZ', dial: '+501', flag: '🇧🇿', name: 'Belize' },
  { code: 'BJ', dial: '+229', flag: '🇧🇯', name: 'Benin' },
  { code: 'BM', dial: '+1441', flag: '🇧🇲', name: 'Bermuda' },
  { code: 'BT', dial: '+975', flag: '🇧🇹', name: 'Bhutan' },
  { code: 'BO', dial: '+591', flag: '🇧🇴', name: 'Bolivia' },
  { code: 'BQ', dial: '+599', flag: '🇧🇶', name: 'Caribbean Netherlands' },
  { code: 'BA', dial: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
  { code: 'BW', dial: '+267', flag: '🇧🇼', name: 'Botswana' },
  { code: 'BV', dial: '+47', flag: '🇧🇻', name: 'Bouvet Island' },
  { code: 'BR', dial: '+55', flag: '🇧🇷', name: 'Brazil' },
  { code: 'IO', dial: '+246', flag: '🇮🇴', name: 'British Indian Ocean Territory' },
  { code: 'BN', dial: '+673', flag: '🇧🇳', name: 'Brunei Darussalam' },
  { code: 'BG', dial: '+359', flag: '🇧🇬', name: 'Bulgaria' },
  { code: 'BF', dial: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: 'BI', dial: '+257', flag: '🇧🇮', name: 'Burundi' },
  { code: 'CV', dial: '+238', flag: '🇨🇻', name: 'Cabo Verde' },
  { code: 'KH', dial: '+855', flag: '🇰🇭', name: 'Cambodia' },
  { code: 'CM', dial: '+237', flag: '🇨🇲', name: 'Cameroon' },
  { code: 'CA', dial: '+1', flag: '🇨🇦', name: 'Canada' },
  { code: 'KY', dial: '+1345', flag: '🇰🇾', name: 'Cayman Islands' },
  { code: 'CF', dial: '+236', flag: '🇨🇫', name: 'Central African Republic' },
  { code: 'TD', dial: '+235', flag: '🇹🇩', name: 'Chad' },
  { code: 'CL', dial: '+56', flag: '🇨🇱', name: 'Chile' },
  { code: 'CN', dial: '+86', flag: '🇨🇳', name: 'China' },
  { code: 'CX', dial: '+61', flag: '🇨🇽', name: 'Christmas Island' },
  { code: 'CC', dial: '+61', flag: '🇨🇨', name: 'Cocos (Keeling) Islands' },
  { code: 'CO', dial: '+57', flag: '🇨🇴', name: 'Colombia' },
  { code: 'KM', dial: '+269', flag: '🇰🇲', name: 'Comoros' },
  { code: 'CD', dial: '+243', flag: '🇨🇩', name: 'Democratic Republic of the Congo' },
  { code: 'CG', dial: '+242', flag: '🇨🇬', name: 'Republic of the Congo' },
  { code: 'CK', dial: '+682', flag: '🇨🇰', name: 'Cook Islands' },
  { code: 'CR', dial: '+506', flag: '🇨🇷', name: 'Costa Rica' },
  { code: 'CI', dial: '+225', flag: '🇨🇮', name: "Côte d'Ivoire" },
  { code: 'HR', dial: '+385', flag: '🇭🇷', name: 'Croatia' },
  { code: 'CU', dial: '+53', flag: '🇨🇺', name: 'Cuba' },
  { code: 'CW', dial: '+5999', flag: '🇨🇼', name: 'Curaçao' },
  { code: 'CY', dial: '+357', flag: '🇨🇾', name: 'Cyprus' },
  { code: 'CZ', dial: '+420', flag: '🇨🇿', name: 'Czech Republic' },
  { code: 'DK', dial: '+45', flag: '🇩🇰', name: 'Denmark' },
  { code: 'DJ', dial: '+253', flag: '🇩🇯', name: 'Djibouti' },
  { code: 'DM', dial: '+1767', flag: '🇩🇲', name: 'Dominica' },
  { code: 'DO', dial: '+1', flag: '🇩🇴', name: 'Dominican Republic' },
  { code: 'EC', dial: '+593', flag: '🇪🇨', name: 'Ecuador' },
  { code: 'EG', dial: '+20', flag: '🇪🇬', name: 'Egypt' },
  { code: 'SV', dial: '+503', flag: '🇸🇻', name: 'El Salvador' },
  { code: 'GQ', dial: '+240', flag: '🇬🇶', name: 'Equatorial Guinea' },
  { code: 'ER', dial: '+291', flag: '🇪🇷', name: 'Eritrea' },
  { code: 'EE', dial: '+372', flag: '🇪🇪', name: 'Estonia' },
  { code: 'SZ', dial: '+268', flag: '🇸🇿', name: 'Eswatini' },
  { code: 'ET', dial: '+251', flag: '🇪🇹', name: 'Ethiopia' },
  { code: 'FK', dial: '+500', flag: '🇫🇰', name: 'Falkland Islands' },
  { code: 'FO', dial: '+298', flag: '🇫🇴', name: 'Faroe Islands' },
  { code: 'FJ', dial: '+679', flag: '🇫🇯', name: 'Fiji' },
  { code: 'FI', dial: '+358', flag: '🇫🇮', name: 'Finland' },
  { code: 'FR', dial: '+33', flag: '🇫🇷', name: 'France' },
  { code: 'GF', dial: '+594', flag: '🇬🇫', name: 'French Guiana' },
  { code: 'PF', dial: '+689', flag: '🇵🇫', name: 'French Polynesia' },
  { code: 'TF', dial: '+262', flag: '🇹🇫', name: 'French Southern Territories' },
  { code: 'GA', dial: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: 'GM', dial: '+220', flag: '🇬🇲', name: 'Gambia' },
  { code: 'GE', dial: '+995', flag: '🇬🇪', name: 'Georgia' },
  { code: 'DE', dial: '+49', flag: '🇩🇪', name: 'Germany' },
  { code: 'GH', dial: '+233', flag: '🇬🇭', name: 'Ghana' },
  { code: 'GI', dial: '+350', flag: '🇬🇮', name: 'Gibraltar' },
  { code: 'GR', dial: '+30', flag: '🇬🇷', name: 'Greece' },
  { code: 'GL', dial: '+299', flag: '🇬🇱', name: 'Greenlandt' },
  { code: 'GD', dial: '+1473', flag: '🇬🇩', name: 'Grenada' },
  { code: 'GP', dial: '+590', flag: '🇬🇵', name: 'Guadeloupe' },
  { code: 'GU', dial: '+1671', flag: '🇬🇺', name: 'Guam' },
  { code: 'GT', dial: '+502', flag: '🇬🇹', name: 'Guatemala' },
  { code: 'GG', dial: '+44', flag: '🇬🇬', name: 'Guernsey' },
  { code: 'GN', dial: '+224', flag: '🇬🇳', name: 'Guinea' },
  { code: 'GW', dial: '+245', flag: '🇬🇼', name: 'Guinea-Bissau' },
  { code: 'GY', dial: '+592', flag: '🇬🇾', name: 'Guyana' },
  { code: 'HT', dial: '+509', flag: '🇭🇹', name: 'Haiti' },
  { code: 'HM', dial: '+0', flag: '🇭🇲', name: 'Heard Island and McDonald Islands' },
  { code: 'VA', dial: '+379', flag: '🇻🇦', name: 'Holy See' },
  { code: 'HN', dial: '+504', flag: '🇭🇳', name: 'Honduras' },
  { code: 'HK', dial: '+852', flag: '🇭🇰', name: 'Hong Kong' },
  { code: 'HU', dial: '+36', flag: '🇭🇺', name: 'Hungary' },
  { code: 'IS', dial: '+354', flag: '🇮🇸', name: 'Iceland' },
  { code: 'IN', dial: '+91', flag: '🇮🇳', name: 'India' },
  { code: 'ID', dial: '+62', flag: '🇮🇩', name: 'Indonesia' },
  { code: 'IR', dial: '+98', flag: '🇮🇷', name: 'Iran' },
  { code: 'IQ', dial: '+964', flag: '🇮🇶', name: 'Iraq' },
  { code: 'IE', dial: '+353', flag: '🇮🇪', name: 'Ireland' },
  { code: 'IM', dial: '+44', flag: '🇮🇲', name: 'Isle of Man' },
  { code: 'IL', dial: '+972', flag: '🇮🇱', name: 'Israel' },
  { code: 'IT', dial: '+39', flag: '🇮🇹', name: 'Italy' },
  { code: 'JM', dial: '+1876', flag: '🇯🇲', name: 'Jamaica' },
  { code: 'JP', dial: '+81', flag: '🇯🇵', name: 'Japan' },
  { code: 'JE', dial: '+44', flag: '🇯🇪', name: 'Jersey' },
  { code: 'JO', dial: '+962', flag: '🇯🇴', name: 'Jordan' },
  { code: 'KZ', dial: '+7', flag: '🇰🇿', name: 'Kazakhstan' },
  { code: 'KE', dial: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: 'KI', dial: '+686', flag: '🇰🇮', name: 'Kiribati' },
  { code: 'KP', dial: '+850', flag: '🇰🇵', name: 'North Korea' },
  { code: 'KR', dial: '+82', flag: '🇰🇷', name: 'South Korea' },
  { code: 'KW', dial: '+965', flag: '🇰🇼', name: 'Kuwait' },
  { code: 'KG', dial: '+996', flag: '🇰🇬', name: 'Kyrgyzstan' },
  { code: 'LA', dial: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: 'XK', dial: '+383', flag: '🇽🇰', name: 'Republika e Kosovës' },
  { code: 'LV', dial: '+371', flag: '🇱🇻', name: 'Latvia' },
  { code: 'LB', dial: '+961', flag: '🇱🇧', name: 'Lebanon' },
  { code: 'LS', dial: '+266', flag: '🇱🇸', name: 'Lesotho' },
  { code: 'LR', dial: '+231', flag: '🇱🇷', name: 'Liberia' },
  { code: 'LY', dial: '+218', flag: '🇱🇾', name: 'Libya' },
  { code: 'LI', dial: '+423', flag: '🇱🇮', name: 'Liechtenstein' },
  { code: 'LT', dial: '+370', flag: '🇱🇹', name: 'Lithuania' },
  { code: 'LU', dial: '+352', flag: '🇱🇺', name: 'Luxembourg' },
  { code: 'MO', dial: '+853', flag: '🇲🇴', name: 'Macao' },
  { code: 'MK', dial: '+389', flag: '🇲🇰', name: 'North Macedonia' },
  { code: 'MG', dial: '+261', flag: '🇲🇬', name: 'Madagascar' },
  { code: 'MW', dial: '+265', flag: '🇲🇼', name: 'Malawi' },
  { code: 'MY', dial: '+60', flag: '🇲🇾', name: 'Malaysia' },
  { code: 'MV', dial: '+960', flag: '🇲🇻', name: 'Maldives' },
  { code: 'ML', dial: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: 'MT', dial: '+356', flag: '🇲🇹', name: 'Malta' },
  { code: 'MH', dial: '+692', flag: '🇲🇭', name: 'Marshall Islands' },
  { code: 'MQ', dial: '+596', flag: '🇲🇶', name: 'Martinique' },
  { code: 'MR', dial: '+222', flag: '🇲🇷', name: 'Mauritania' },
  { code: 'MU', dial: '+230', flag: '🇲🇺', name: 'Mauritius' },
  { code: 'YT', dial: '+262', flag: '🇾🇹', name: 'Mayotte' },
  { code: 'MX', dial: '+52', flag: '🇲🇽', name: 'Mexico' },
  { code: 'FM', dial: '+691', flag: '🇫🇲', name: 'Micronesia' },
  { code: 'MD', dial: '+373', flag: '🇲🇩', name: 'Moldova' },
  { code: 'MC', dial: '+377', flag: '🇲🇨', name: 'Monaco' },
  { code: 'MN', dial: '+976', flag: '🇲🇳', name: 'Mongolia' },
  { code: 'ME', dial: '+382', flag: '🇲🇪', name: 'Montenegro' },
  { code: 'MS', dial: '+1664', flag: '🇲🇸', name: 'Montserrat' },
  { code: 'MA', dial: '+212', flag: '🇲🇦', name: 'Morocco' },
  { code: 'MZ', dial: '+258', flag: '🇲🇿', name: 'Mozambique' },
  { code: 'MM', dial: '+95', flag: '🇲🇲', name: 'Myanmar' },
  { code: 'NA', dial: '+264', flag: '🇳🇦', name: 'Namibia' },
  { code: 'NR', dial: '+674', flag: '🇳🇷', name: 'Nauru' },
  { code: 'NP', dial: '+977', flag: '🇳🇵', name: 'Nepal' },
  { code: 'NL', dial: '+31', flag: '🇳🇱', name: 'Netherlands' },
  { code: 'NC', dial: '+687', flag: '🇳🇨', name: 'New Caledonia' },
  { code: 'NZ', dial: '+64', flag: '🇳🇿', name: 'New Zealand' },
  { code: 'NI', dial: '+505', flag: '🇳🇮', name: 'Nicaragua' },
  { code: 'NE', dial: '+227', flag: '🇳🇪', name: 'Niger' },
  { code: 'NG', dial: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: 'NU', dial: '+683', flag: '🇳🇺', name: 'Niue' },
  { code: 'NF', dial: '+672', flag: '🇳🇫', name: 'Norfolk Island' },
  { code: 'MP', dial: '+1670', flag: '🇲🇵', name: 'Northern Mariana Islands' },
  { code: 'NO', dial: '+47', flag: '🇳🇴', name: 'Norway' },
  { code: 'OM', dial: '+968', flag: '🇴🇲', name: 'Oman' },
  { code: 'PK', dial: '+92', flag: '🇵🇰', name: 'Pakistan' },
  { code: 'PW', dial: '+680', flag: '🇵🇼', name: 'Palau' },
  { code: 'PS', dial: '+970', flag: '🇵🇸', name: 'Palestine' },
  { code: 'PA', dial: '+507', flag: '🇵🇦', name: 'Panama' },
  { code: 'PG', dial: '+675', flag: '🇵🇬', name: 'Papua New Guinea' },
  { code: 'PY', dial: '+595', flag: '🇵🇾', name: 'Paraguay' },
  { code: 'PE', dial: '+51', flag: '🇵🇪', name: 'Perú' },
  { code: 'PH', dial: '+63', flag: '🇵🇭', name: 'Philippines' },
  { code: 'PN', dial: '+64', flag: '🇵🇳', name: 'Pitcairn Islands' },
  { code: 'PL', dial: '+48', flag: '🇵🇱', name: 'Poland' },
  { code: 'PT', dial: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: 'PR', dial: '+1939', flag: '🇵🇷', name: 'Puerto Rico' },
  { code: 'QA', dial: '+974', flag: '🇶🇦', name: 'Qatar' },
  { code: 'RE', dial: '+262', flag: '🇷🇪', name: 'Réunion' },
  { code: 'RO', dial: '+40', flag: '🇷🇴', name: 'Romania' },
  { code: 'RU', dial: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: 'RW', dial: '+250', flag: '🇷🇼', name: 'Rwanda' },
  { code: 'BL', dial: '+590', flag: '🇧🇱', name: 'Saint Barthélemy' },
  { code: 'SH', dial: '+290', flag: '🇸🇭', name: 'Saint Helena' },
  { code: 'KN', dial: '+1869', flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
  { code: 'LC', dial: '+1758', flag: '🇱🇨', name: 'Saint Lucia' },
  { code: 'MF', dial: '+590', flag: '🇲🇫', name: 'Saint Martin' },
  { code: 'PM', dial: '+508', flag: '🇵🇲', name: 'Saint Pierre and Miquelon' },
  { code: 'VC', dial: '+1784', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', dial: '+685', flag: '🇼🇸', name: 'Samoa' },
  { code: 'SM', dial: '+378', flag: '🇸🇲', name: 'San Marino' },
  { code: 'ST', dial: '+239', flag: '🇸🇹', name: 'São Tomé and Príncipe' },
  { code: 'SA', dial: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: 'SN', dial: '+221', flag: '🇸🇳', name: 'Senegal' },
  { code: 'RS', dial: '+381', flag: '🇷🇸', name: 'Serbia' },
  { code: 'SC', dial: '+248', flag: '🇸🇨', name: 'Seychelles' },
  { code: 'SL', dial: '+232', flag: '🇸🇱', name: 'Sierra Leone' },
  { code: 'SG', dial: '+65', flag: '🇸🇬', name: 'Singapore' },
  { code: 'SX', dial: '+1721', flag: '🇸🇽', name: 'Sint Maarten' },
  { code: 'SK', dial: '+421', flag: '🇸🇰', name: 'Slovakia' },
  { code: 'SI', dial: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: 'SB', dial: '+677', flag: '🇸🇧', name: 'Solomon Islands' },
  { code: 'SO', dial: '+252', flag: '🇸🇴', name: 'Somalia' },
  { code: 'ZA', dial: '+27', flag: '🇿🇦', name: 'South Africa' },
  { code: 'GS', dial: '+500', flag: '🇬🇸', name: 'South Georgia and the South Sandwich Islands' },
  { code: 'SS', dial: '+211', flag: '🇸🇸', name: 'South Sudan' },
  { code: 'ES', dial: '+34', flag: '🇪🇸', name: 'Spain' },
  { code: 'LK', dial: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: 'SD', dial: '+249', flag: '🇸🇩', name: 'Sudan' },
  { code: 'SR', dial: '+597', flag: '🇸🇷', name: 'Suriname' },
  { code: 'SJ', dial: '+47', flag: '🇸🇯', name: 'Svalbard and Jan Mayen' },
  { code: 'SE', dial: '+46', flag: '🇸🇪', name: 'Sweden' },
  { code: 'CH', dial: '+41', flag: '🇨🇭', name: 'Switzerland' },
  { code: 'SY', dial: '+963', flag: '🇸🇾', name: 'Syria' },
  { code: 'TW', dial: '+886', flag: '🇹🇼', name: 'Taiwan' },
  { code: 'TJ', dial: '+992', flag: '🇹🇯', name: 'Tajikistan' },
  { code: 'TZ', dial: '+255', flag: '🇹🇿', name: 'Tanzania' },
  { code: 'TH', dial: '+66', flag: '🇹🇭', name: 'Thailand' },
  { code: 'TL', dial: '+670', flag: '🇹🇱', name: 'Timor-Leste' },
  { code: 'TG', dial: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: 'TK', dial: '+690', flag: '🇹🇰', name: 'Tokelau' },
  { code: 'TO', dial: '+676', flag: '🇹🇴', name: 'Tonga' },
  { code: 'TT', dial: '+1868', flag: '🇹🇹', name: 'Trinidad and Tobago' },
  { code: 'TN', dial: '+216', flag: '🇹🇳', name: 'Tunisia' },
  { code: 'TR', dial: '+90', flag: '🇹🇷', name: 'Turkey' },
  { code: 'TM', dial: '+993', flag: '🇹🇲', name: 'Turkmenistan' },
  { code: 'TC', dial: '+1649', flag: '🇹🇨', name: 'Turks and Caicos Islands' },
  { code: 'TV', dial: '+688', flag: '🇹🇻', name: 'Tuvalu' },
  { code: 'UG', dial: '+256', flag: '🇺🇬', name: 'Uganda' },
  { code: 'UA', dial: '+380', flag: '🇺🇦', name: 'Ukraine' },
  { code: 'AE', dial: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
  { code: 'GB', dial: '+44', flag: '🇬🇧', name: 'United Kingdom' },
  { code: 'UM', dial: '+246', flag: '🇺🇲', name: 'United States Minor Outlying Islands' },
  { code: 'US', dial: '+1', flag: '🇺🇸', name: 'United States' },
  { code: 'UY', dial: '+598', flag: '🇺🇾', name: 'Uruguay' },
  { code: 'UZ', dial: '+998', flag: '🇺🇿', name: 'Uzbekistan' },
  { code: 'VU', dial: '+678', flag: '🇻🇺', name: 'Vanuatu' },
  { code: 'VE', dial: '+58', flag: '🇻🇪', name: 'Venezuela' },
  { code: 'VN', dial: '+84', flag: '🇻🇳', name: 'Viet Nam' },
  { code: 'VG', dial: '+1284', flag: '🇻🇬', name: 'British Virgin Islands' },
  { code: 'VI', dial: '+1340', flag: '🇻🇮', name: 'United States Virgin Islands' },
  { code: 'WF', dial: '+681', flag: '🇼🇫', name: 'Wallis and Futuna' },
  { code: 'EH', dial: '+212', flag: '🇪🇭', name: 'Western Sahara' },
  { code: 'YE', dial: '+967', flag: '🇾🇪', name: 'Yemen' },
  { code: 'ZM', dial: '+260', flag: '🇿🇲', name: 'Zambia' },
  { code: 'ZW', dial: '+263', flag: '🇿🇼', name: 'Zimbabwe' },
];

export const CURRENCY_CODES = [
  'USD',
  'ANG',
  'GBP',
  'EUR',
  'RSD',
  'SSP',
  'AOA',
  'XCD',
  'ARS',
  'AMD',
  'AWG',
  'AUD',
  'AZN',
  'BHD',
  'BDT',
  'BBD',
  'BYN',
  'BZD',
  'XOF',
  'BMD',
  'BTN',
  'BOB',
  'BAM',
  'BWP',
  'BRL',
  'BND',
  'BGN',
  'BIF',
  'KHR',
  'XAF',
  'CAD',
  'CVE',
  'KYD',
  'CLP',
  'CNY',
  'COP',
  'KMF',
  'CDF',
  'CKD',
  'CRC',
  'HRK',
  'CUP',
  'CZK',
  'DKK',
  'DJF',
  'DOP',
  'EGP',
  'ERN',
  'ETB',
  'FJD',
  'XPF',
  'GMD',
  'GEL',
  'GHS',
  'GIP',
  'GTQ',
  'GNF',
  'GYD',
  'HTG',
  'HNL',
  'HKD',
  'HUF',
  'ISK',
  'INR',
  'IDR',
  'IRR',
  'IQD',
  'ILS',
  'JMD',
  'JPY',
  'JOD',
  'KZT',
  'KES',
  'KPW',
  'KRW',
  'KWD',
  'KGS',
  'LAK',
  'LBP',
  'LSL',
  'LRD',
  'LYD',
  'CHF',
  'MOP',
  'MKD',
  'MGA',
  'MWK',
  'MYR',
  'MVR',
  'MRO',
  'MUR',
  'MXN',
  'MDL',
  'MNT',
  'ALL',
  'MAD',
  'MZN',
  'MMK',
  'NAD',
  'NPR',
  'NZD',
  'NIO',
  'NGN',
  'NOK',
  'OMR',
  'PKR',
  'PAB',
  'PGK',
  'PYG',
  'PEN',
  'PHP',
  'PLN',
  'QAR',
  'RON',
  'RUB',
  'RWF',
  'SHP',
  'WST',
  'STD',
  'SAR',
  'SCR',
  'SLL',
  'SGD',
  'SBD',
  'SOS',
  'ZAR',
  'LKR',
  'SDG',
  'SRD',
  'SZL',
  'SEK',
  'SYP',
  'TWD',
  'TJS',
  'TZS',
  'THB',
  'TOP',
  'TTD',
  'TND',
  'TRY',
  'TMT',
  'UGX',
  'UAH',
  'AED',
  'UYU',
  'UZS',
  'VUV',
  'VEF',
  'VND',
  'YER',
  'ZMW',
  'ZWL',
  'AFN',
  'DZD',
];

// NB: first value of enum arrays are used as defaults
